import { Components } from '@mui/material/styles/components';
import { ControllerCardColor } from '../../palette';

// const theme = createTheme();

export const CardComponent: Components = {
  MuiCard: {
    styleOverrides: {
      root: {
        borderColor: String(ControllerCardColor.Border),
        borderRadius: 0,
      },
    },
  },
};
